import React, { useCallback } from "react";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import TableCell from "@mui/material/TableCell";

export default function Pager({
	colSpan,
	count,
	dispatch,
	page,
	pageSizes,
	currentPageSize,
	setPage,
	setCurrentPageSize,
}) {
	const handlePage = useCallback(
		(event) => {
			setPage(event);
		},
		[setPage]
	);

	return (
		<TableFooter>
			<TableRow>
				<TableCell
					colSpan={colSpan}
					sx={{
						borderTop: 1,
						borderColor: "grey.300",
					}}
				>
					<Grid container>
						<Grid item xs={12} sm={3}>
							<FormControl
								fullWidth={true}
								variant="standard"
								sx={{ minWidth: 100 }}
							>
								<InputLabel id="perpagelabel">Items per Page</InputLabel>
								<Select
									labelId="perpagelabel"
									label="Items per Page"
									value={currentPageSize}
									onChange={(e) => dispatch(setCurrentPageSize(e.target.value))}
								>
									{pageSizes.map((size, index) => (
										<MenuItem key={index} value={size}>
											{size}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={9} justifyContent="flex-end">
							<Grid container justifyContent="flex-end">
								<Stack spacing={2}>
									<Pagination
										count={count}
										page={page}
										onChange={(e, val) => handlePage(val)}
										color="primary"
										siblingCount={1}
										boundaryCount={1}
									/>
								</Stack>
							</Grid>
						</Grid>
					</Grid>
				</TableCell>
			</TableRow>
		</TableFooter>
	);
}
